// extracted by mini-css-extract-plugin
export default {"root":"_2uud3","animationRun":"_2d5Vu","favorite-success-action":"_1bCfp","animationClose":"TPDw_","favorite-close-action":"_3Nz1V"};